package com.iregained.eventapp.utils

import androidx.compose.runtime.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.window
import org.w3c.dom.events.Event

val LocalBreakpoint = staticCompositionLocalOf { Breakpoint.ZERO }

@Composable
fun rememberBreakpoint(): State<Breakpoint> {
    val breakpoint = remember { mutableStateOf(calculateBreakpoint()) }

    LaunchedEffect(Unit) {
        val listener: (Event) -> Unit = {
            breakpoint.value = calculateBreakpoint()
        }
        window.addEventListener("resize", listener)
    }

    return breakpoint
}

private fun calculateBreakpoint(): Breakpoint {
    val width = window.innerWidth
    return when {
        width >= 1440 -> Breakpoint.XXL
        width >= 1280 -> Breakpoint.XL
        width >= 1024 -> Breakpoint.LG
        width >= 768 -> Breakpoint.MD
        width >= 640 -> Breakpoint.SM
        else -> Breakpoint.ZERO
    }
}